<template>
  <v-col :class="$vuetify.breakpoint.mdAndUp ? 'col-84' : 'col-12'" class="pa-5">
    <v-card>
      <v-card-title>
        <span class="Subtitle 1">Upload Documents</span>
      </v-card-title>
      <v-card-text>
        <vue-dropzone
          class="vue-dropzone-box dz-error-message"
          ref="myVueDropzone"
          id="dropzone"
          :destroyDropzone="false"
          :options="dropzoneOptionsForDocuments"
          @vdropzone-sending="beforecomplete"
          @vdropzone-success="aftercomplete"
          @vdropzone-mounted="uploadedImage"
          @vdropzone-removed-file="removeFile"
          :useCustomSlot="true"
        >
          <div class="dropzone-custom-content">
            <img src="@/assets/images/FileUpload.svg" />
            <h3 class="font-weight-light ma-0">Drag and drop here to upload</h3>
            <h3 class="font-weight-light ma-0">Or</h3>
            <h3 class="dropzone-custom-title">Browse</h3>
          </div>
        </vue-dropzone>
      </v-card-text>
    </v-card>
    <div class="upload-message">*You can upload file with maximum 30MB size. You can upload maximum {{maxFiles}} files.</div>
  </v-col>
</template>

<script>
import store from "@/store";
import vue2Dropzone from "vue2-dropzone";
import "../assets/scss/core/vue2-Dropzone/vue2Dropzone.min.css";
import { MediaService } from "@/services";

export default {
  name: "DocumentUpload",
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    documents: Array,
    moduleName: String,
    moduleId: String,
    maxFiles:{
     type: Number,
     default:5
    }
  },
  data() {
    const self = this;
    return {
      dropzoneOptionsForDocuments: {
        url: `${process.env.VUE_APP_SERVERURL}media`,
        maxFilesize: 30, // MB
        chunking: false,
        addRemoveLinks: true,
        maxFiles: self.maxFiles,
        autoProcessQueue: true,
        dictFileTooBig:"File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        init() {
          this.on("maxfilesexceeded", function(file) {
             this.removeFile(file);
          });
          this.on("addedfile", file => {
            if (file.size > 1024 * 1024 * 30) {
              // not more than 30mb
              this.removeFile(file);
            }
          });
        },
        headers: {
          Authorization: `Bearer ${store.state.user.token}`,
        },
      },
    };
  },
  methods: {
    beforecomplete(file, xhr, formData) {
      formData.append("mediaType", "doc");
      formData.append("mediaSubType", "file");
      formData.append("moduleType", this.moduleName);
      formData.append("moduleId", this.moduleId);
    },
    aftercomplete(file, response) {
      if (response) {
        this.documents.push(response);
      }
      this.$store.dispatch("user/setSnack", "Document uploaded successfully!");
      this.$store.dispatch("user/setType", "info");
    },
    uploadedImage() {
      if (this.documents && this.documents.length > 0) {
        this.documents.filter((media) => {
          if (media.mediaType == "image" || media.mediaType == "doc") {
            var file = {
              size: media.size,
              name: media.name,
              type: media.type,
            };
            this.$refs.myVueDropzone.manuallyAddFile(file, media.url);
          }
        });
      }
    },
    removeFile(file, error, xhr) {
      if (file.size > 1024 * 1024 * 30) {
        this.$store.dispatch(
          "user/setSnack",
          "Upto 30MB File size is allowed"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.deletePicture(file);
    },
    async deletePicture(file) {
      if (file) {
        let mediaId = this.documents.filter((media) => {
          if (media.name == file.name) {
            return media._id;
          }
        });
        const response = await MediaService.deleteMedia({
          id: mediaId[0]._id,
          body: {
            moduleType: this.moduleName,
            moduleId: this.moduleId,
          },
        });
        if (response) {
          for (var i = 0; i < this.documents.length; i++) {
            if (this.documents[i].name === file.name) {
              this.documents.splice(i, 1);
            }
          }
          this.$store.dispatch(
            "user/setSnack",
            "Document deleted successfully!"
          );
          this.$store.dispatch("user/setType", "info");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dz-error-message {
  opacity: 1 !important;
  top: 75px !important;
}
</style>